import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import { getNameStateByCode } from '../Blocks/LinkMap/states';

const compareTags = (a, b) => a.localeCompare(b);

const getTagText = (value) => {
  if (!value) return '';

  if (typeof value === 'string') return value;

  if (typeof value === 'object' && value?.title) {
    return typeof value.title === 'object' && value.title?.title
      ? value.title.title
      : value.title;
  }

  return '';
};

const normalizeStateTag = (value) => {
  const rawValue = getTagText(value);
  if (!rawValue) return value;

  const normalizedState = getNameStateByCode(rawValue);
  if (normalizedState) return normalizedState;

  return rawValue;
};

const TagsUFs = (props) => {
  const { className, content, slotView } = props;
  const subjectTags = new Set();
  const stateTags = new Set();

  if (content?.subjects?.length) {
    content.subjects.forEach((subject) => {
      const subjectText = getTagText(subject);
      if (subjectText) subjectTags.add(subjectText);
    });
  }

  if (content?.uf_noticia?.length) {
    content.uf_noticia.forEach((item) => {
      const stateTag = normalizeStateTag(item?.title || item);
      if (stateTag) stateTags.add(stateTag);
    });
  }

  const orderedSubjectTags = Array.from(subjectTags).sort(compareTags);
  const orderedStateTags = Array.from(stateTags).sort(compareTags);
  const uniqueTags = [...orderedSubjectTags, ...orderedStateTags];

  const Wrapper = slotView ? Container : 'div';

  return uniqueTags.length > 0 ? (
    <Wrapper
      className={cx('tags d-flex flex-wrap align-items-center', className)}
    >
      <span
        style={{ lineHeight: 1.45 }}
        className="label text-base m-0 mr-1 py-1"
      >
        Tags:
      </span>
      {uniqueTags.map((tag) => (
        <Link
          className="br-button tertiary small text-base px-2 py-1"
          to={`/search?origem=keyword&SearchableText=${tag}`}
          key={tag}
          style={{ height: 'auto !important' }}
        >
          {tag}
        </Link>
      ))}
    </Wrapper>
  ) : (
    <span />
  );
};

export default TagsUFs;
